import React, { useState } from "react";
import {
  Routes,
  Route
} from "react-router-dom";

import Home from "./components/Home";
import { Landing } from "./components/Landing";
import { Upload } from "./components/Upload";


const App = () => {
  const [response, setResponse] = useState('../downloadIcon.png') 

  return (
    <Routes>
      <Route path="/" element={<Landing/>}></Route>
      <Route path="/art" element={<Home setResponse={setResponse}/>}></Route>
      <Route path="/ads" element={<Upload/>}></Route>
    </Routes>
  );
}

export default App;
